__turbopack_context__.v({
  "buttonWrapper": "StepFormHeader-module-scss-module__WjG5MG__buttonWrapper",
  "header": "StepFormHeader-module-scss-module__WjG5MG__header",
  "root": "StepFormHeader-module-scss-module__WjG5MG__root",
  "subtitle": "StepFormHeader-module-scss-module__WjG5MG__subtitle",
  "suptitle": "StepFormHeader-module-scss-module__WjG5MG__suptitle",
  "title": "StepFormHeader-module-scss-module__WjG5MG__title",
});
